export const calculateTimeDifferenceFromNow = (endDateStr) => {
    // Поточна дата
    const currentDate = new Date();

    // Перетворюємо end_date з рядка в Date
    const endDate = new Date(endDateStr);

    // Різниця між датами в мілісекундах
    const timeDiff = endDate - currentDate;

    // Перетворюємо мілісекунди на дні та години
    const daysLeft = Math.floor(timeDiff / (1000 * 60 * 60 * 24)); // Дні
    const hoursLeft = Math.floor((timeDiff % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60)); // Години
    const minutesLeft = Math.floor((timeDiff % (1000 * 60 * 60)) / (1000 * 60)); // Хвилини

    return { days: daysLeft, hours: hoursLeft, minutes: minutesLeft };
}